/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AssociatedDrug,
    AssociatedDrugFromJSON,
    AssociatedDrugToJSON,
} from '../models/AssociatedDrug';
import {
    type KnownMutation,
    KnownMutationFromJSON,
    KnownMutationToJSON,
} from '../models/KnownMutation';
import {
    type ProteinResponse,
    ProteinResponseFromJSON,
    ProteinResponseToJSON,
} from '../models/ProteinResponse';
import {
    type Uniprot,
    UniprotFromJSON,
    UniprotToJSON,
} from '../models/Uniprot';

export interface FindMutationsRequest {
    codeAscii: string;
}

export interface FindMutations1Request {
    codeAscii: string;
    position: number;
}

export interface GetRequest {
    codeAscii: string;
}

export interface GetAssociatedDrugsRequest {
    codeAscii: string;
}

export interface GetMutationRequest {
    codeAscii: string;
    position: number;
    targetAA: string;
}

export interface GetUniprotRequest {
    codeAscii: string;
    position?: number;
}

export interface ImageRequest {
    codeAscii: string;
    topologicalDomain: string;
}

/**
 * 
 */
export class ProteinControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for findMutations without sending the request
     */
    async findMutationsRequestOpts(requestParameters: FindMutationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling findMutations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/knownMutations`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findMutationsRaw(requestParameters: FindMutationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KnownMutation>>> {
        const requestOptions = await this.findMutationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KnownMutationFromJSON));
    }

    /**
     */
    async findMutations(requestParameters: FindMutationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KnownMutation>> {
        const response = await this.findMutationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findMutations1 without sending the request
     */
    async findMutations1RequestOpts(requestParameters: FindMutations1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling findMutations1().'
            );
        }

        if (requestParameters['position'] == null) {
            throw new runtime.RequiredError(
                'position',
                'Required parameter "position" was null or undefined when calling findMutations1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/knownMutations/{position}`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));
        urlPath = urlPath.replace('{position}', encodeURIComponent(String(requestParameters['position'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async findMutations1Raw(requestParameters: FindMutations1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KnownMutation>>> {
        const requestOptions = await this.findMutations1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KnownMutationFromJSON));
    }

    /**
     */
    async findMutations1(requestParameters: FindMutations1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KnownMutation>> {
        const response = await this.findMutations1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for get without sending the request
     */
    async getRequestOpts(requestParameters: GetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling get().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getRaw(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProteinResponse>> {
        const requestOptions = await this.getRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProteinResponseFromJSON(jsonValue));
    }

    /**
     */
    async get(requestParameters: GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProteinResponse> {
        const response = await this.getRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAssociatedDrugs without sending the request
     */
    async getAssociatedDrugsRequestOpts(requestParameters: GetAssociatedDrugsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling getAssociatedDrugs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/uniprot/associatedDrugs`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAssociatedDrugsRaw(requestParameters: GetAssociatedDrugsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssociatedDrug>>> {
        const requestOptions = await this.getAssociatedDrugsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssociatedDrugFromJSON));
    }

    /**
     */
    async getAssociatedDrugs(requestParameters: GetAssociatedDrugsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssociatedDrug>> {
        const response = await this.getAssociatedDrugsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMutation without sending the request
     */
    async getMutationRequestOpts(requestParameters: GetMutationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling getMutation().'
            );
        }

        if (requestParameters['position'] == null) {
            throw new runtime.RequiredError(
                'position',
                'Required parameter "position" was null or undefined when calling getMutation().'
            );
        }

        if (requestParameters['targetAA'] == null) {
            throw new runtime.RequiredError(
                'targetAA',
                'Required parameter "targetAA" was null or undefined when calling getMutation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/knownMutations/{position}/{targetAA}`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));
        urlPath = urlPath.replace('{position}', encodeURIComponent(String(requestParameters['position'])));
        urlPath = urlPath.replace('{targetAA}', encodeURIComponent(String(requestParameters['targetAA'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMutationRaw(requestParameters: GetMutationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KnownMutation>> {
        const requestOptions = await this.getMutationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KnownMutationFromJSON(jsonValue));
    }

    /**
     */
    async getMutation(requestParameters: GetMutationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KnownMutation> {
        const response = await this.getMutationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUniprot without sending the request
     */
    async getUniprotRequestOpts(requestParameters: GetUniprotRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling getUniprot().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['position'] != null) {
            queryParameters['position'] = requestParameters['position'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/uniprot`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUniprotRaw(requestParameters: GetUniprotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Uniprot>> {
        const requestOptions = await this.getUniprotRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UniprotFromJSON(jsonValue));
    }

    /**
     */
    async getUniprot(requestParameters: GetUniprotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Uniprot> {
        const response = await this.getUniprotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for image without sending the request
     */
    async imageRequestOpts(requestParameters: ImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['codeAscii'] == null) {
            throw new runtime.RequiredError(
                'codeAscii',
                'Required parameter "codeAscii" was null or undefined when calling image().'
            );
        }

        if (requestParameters['topologicalDomain'] == null) {
            throw new runtime.RequiredError(
                'topologicalDomain',
                'Required parameter "topologicalDomain" was null or undefined when calling image().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins/{codeAscii}/topologicalDomains/{topologicalDomain}/structure.png`;
        urlPath = urlPath.replace('{codeAscii}', encodeURIComponent(String(requestParameters['codeAscii'])));
        urlPath = urlPath.replace('{topologicalDomain}', encodeURIComponent(String(requestParameters['topologicalDomain'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async imageRaw(requestParameters: ImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.imageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async image(requestParameters: ImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.imageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for list without sending the request
     */
    async listRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/proteins`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async listRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProteinResponse>>> {
        const requestOptions = await this.listRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProteinResponseFromJSON));
    }

    /**
     */
    async list(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProteinResponse>> {
        const response = await this.listRaw(initOverrides);
        return await response.value();
    }

}
